import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { ResultsSection } from '../components/ResultsSection';
import { PricingSection } from '../components/PricingSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
export const Landing: React.FC = () => {
  return <div className="min-h-screen bg-brand-offwhite font-sans text-brand-charcoal selection:bg-brand-mint selection:text-brand-charcoal" data-id="element-174">
      <Navbar data-id="element-175" />
      <main data-id="element-176">
        <Hero data-id="element-177" />
        <ProblemSection data-id="element-178" />
        <SolutionSection data-id="element-179" />
        <WhatsInsideSection data-id="element-180" />
        <ResultsSection data-id="element-181" />
        <PricingSection data-id="element-182" />
        <FaqSection data-id="element-183" />
        <FinalCtaSection data-id="element-184" />
      </main>
      <Footer data-id="element-185" />
    </div>;
};